/**
 * @generated SignedSource<<8a7171a8330f8a2b018bac83f195da0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type dataValidationCustomRulesListQuery$variables = {
  owner?: string | null;
};
export type dataValidationCustomRulesListQuery$data = {
  readonly validationCustomRulesList: ReadonlyArray<{
    readonly displayName: string;
    readonly resourceName: string;
  } | null> | null;
};
export type dataValidationCustomRulesListQuery = {
  response: dataValidationCustomRulesListQuery$data;
  variables: dataValidationCustomRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      }
    ],
    "concreteType": "ValidationCustomRuleSummary",
    "kind": "LinkedField",
    "name": "validationCustomRulesList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resourceName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dataValidationCustomRulesListQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dataValidationCustomRulesListQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "597e588064d036f7c6c6d38734ad79ad",
    "id": null,
    "metadata": {},
    "name": "dataValidationCustomRulesListQuery",
    "operationKind": "query",
    "text": "query dataValidationCustomRulesListQuery(\n  $owner: String\n) {\n  validationCustomRulesList(owner: $owner) {\n    resourceName\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "a159c179a6ec890e0abbac6881c32369";

export default node;
